import React, { useEffect, useState } from 'react'
import { usePotential } from '../PotentialContext/PotentialContext'
// import { Accounts } from '../../../enums/accounts';
// import { getSingleRetirmentDistributions } from '../utils/singleRetirementHelpers';
import { getTaxableRetirmentDistributions } from '../utils/taxableRetirementHelpers';
import PotentialDisclaimer from '../PotentialDisclaimer/PotentialDisclaimer';
import PotentialChart from '../PotentialChart/PotentialChart';
// import SimpleIRADistribution from '../Distributions/components/SimpleIRADistribution/SimpleIRADistribution';
import TaxableDistribution from '../Distributions/components/TaxableDistribution/TaxableDistribution';
import { POTENTIAL_CALCULATOR_DISCLAIMER_TEXT } from '../../../constants/constants';

const Potential = () => {
    const { userInfo } = usePotential();
    const { 
        initialPortfolioValue,
        // accountType,
        // age,
        contributionItem,
        investmentYears,
        distributionYears,
        // distributionAgeIRA,
        internalReturnRate,
    } = userInfo;

    const [chartData, setChartData] = useState(null);
    const [chartStats, setChartStats] = useState(null);
    const isDefault = true;

    useEffect(() => {
        // NOTE
        //  --- Currently we want all account types to use taxableRetirementDistributions ---
        // NOTE

        const results = getTaxableRetirmentDistributions(
            contributionItem, 
            initialPortfolioValue, 
            investmentYears,
            distributionYears,
            internalReturnRate
        );
        
        const { data, stats } = results
            setChartData(data);
            setChartStats(stats);

        return;
    }, [userInfo])

    return (
        <div style={{display: 'flex', flexDirection: 'column'}}>
        {/* Stats and Chart */}
            <div style={{ display: "flex", flexDirection: 'row-reverse'}}>
                {/* Chart */}
                <div style={{ flex: "2 1 70%" }}>
                    <PotentialChart data={chartData} />
                </div>

                {/* Stats */}
                <div style={{ flex: "1 1 30%" }}>
                    {isDefault && chartStats && <TaxableDistribution data={chartStats} />}
                </div>
            </div>

            {/* Disclaimer */}
            <div style={{marginTop: '32px', marginBottom: '8px'}}>
                <PotentialDisclaimer text={POTENTIAL_CALCULATOR_DISCLAIMER_TEXT} />
            </div>
        </div>
    )
}

export default Potential